import { Button } from '@planuze/ui';
import { useCompaniesListContent } from '../../content/sections/companies-list.js';
import { BulkSelectionBar } from '../bulk-selection-bar.js';

interface Props {
  readonly selectedCount: number;
  readonly busy: boolean;
  readonly onBlock: () => void;
  readonly onUnblock: () => void;
  readonly onClear: () => void;
}

export function CompanyBulkBar({ selectedCount, busy, onBlock, onUnblock, onClear }: Props) {
  const copy = useCompaniesListContent().bulk;
  if (selectedCount === 0) return null;
  return (
    <BulkSelectionBar
      selectedLabel={copy.selected(selectedCount)}
      clearLabel={copy.clear}
      busy={busy}
      onClear={onClear}
    >
      <Button size="sm" variant="destructive" disabled={busy} onClick={onBlock}>
        {copy.block}
      </Button>
      <Button size="sm" disabled={busy} onClick={onUnblock}>
        {copy.unblock}
      </Button>
    </BulkSelectionBar>
  );
}
